import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnterPressDirective } from './enter-press.directive';

@NgModule({
  declarations: [EnterPressDirective],
  imports: [CommonModule],
  exports: [EnterPressDirective],
})
export class EnterPressModule {}
